<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Retenciones
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Administración de Retenciones

    //- Modal para ver comprobante ampliado
    v-dialog(v-model='dialogImg', max-width='920px')
      v-card(style="background-color: white;")
        v-card-title(style="background: #111; color: white; padding: 12px 18px;")
          span Comprobante de Retención - {{ itemSel ? itemSel.nro_retencion : '' }}
          v-spacer
          v-btn(icon dark @click='dialogImg = false')
            v-icon mdi-close
        v-card-text(style="padding: 16px;")
          div(v-if="itemSel && itemSel.comprobante")
            div(v-if="itemSel.comprobante.toLowerCase().endsWith('.pdf')")
              div(style="display: flex; justify-content: flex-end; align-items: center; gap: 8px; margin-bottom: 12px; flex-wrap: wrap;")
                v-btn(small outline :color="visorPdfModo === 'google' ? 'primary' : 'grey'" @click="visorPdfModo = 'google'")
                  v-icon(left small) preview
                  | Visor Web
                v-btn(small outline :color="visorPdfModo === 'nativo' ? 'primary' : 'grey'" @click="visorPdfModo = 'nativo'")
                  v-icon(left small) picture_as_pdf
                  | Visor Directo
                v-btn(small flat color="primary" :href="urlPdfDirecta" target="_blank")
                  v-icon(left small) open_in_new
                  | Abrir en Pestaña

              iframe(:src="urlPdfActual" style="width: 100%; height: 75vh; border: 1px solid #e2e8f0; border-radius: 8px; background: #f8fafc;")
            div.text-xs-center(v-else)
              a(:href="ruta + itemSel.comprobante" target="_blank" title="Abrir en pestaña nueva")
                img(:src="ruta + itemSel.comprobante", style="max-width: 100%; max-height: 75vh; object-fit: contain; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15);")
              div(style="margin-top: 10px;")
                a(:href="ruta + itemSel.comprobante" target="_blank" style="color: #0872E9; text-decoration: none; font-weight: 600;")
                  v-icon(small color="primary") open_in_new
                  |  Abrir imagen en tamaño completo
          div.text-xs-center(v-else style="padding: 40px; color: #888;")
            v-icon(size="48" color="grey") mdi-image-off
            div No posee comprobante adjunto

    //- Modal de detalle y acciones
    v-dialog(v-model='dialogDetalle', persistent max-width='700px')
      v-card(style='background-color:white !important;')
        v-card-title.justify-center(style="background: black; color: white; padding: 10px;")
          span.headline(style="font-size: 18px !important;") Solicitud de Retención # {{ form.nro }}
        v-card-text(style="padding: 20px;")
          v-layout(row wrap)
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.nro_retencion" label="N° de Retención:" prepend-inner-icon="tag")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.montoDisplay" label="Monto Retenido:" prepend-inner-icon="attach_money")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.clienteNombre" label="Cliente:" prepend-inner-icon="business")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.clienteRif" label="RIF Cliente:" prepend-inner-icon="badge")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.vendedorNombre" label="Vendedor:" prepend-inner-icon="person")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.fechaFormateada" label="Fecha de Registro:" prepend-inner-icon="event")
            v-flex(xs12)
              v-text-field(outline readonly v-model="form.estatus" label="Estatus actual:" prepend-inner-icon="info")
            v-flex(xs12 v-if="form.observacion")
              v-textarea(outline readonly v-model="form.observacion" :label="form.estatus === 'Rechazado' ? 'Motivo del Rechazo:' : 'Observación:'" prepend-inner-icon="notes" rows="2")

            //- Tabla de facturas afectadas si existen
            v-flex(xs12 v-if="form.facturas && form.facturas.length > 0" style="margin-top: 10px;")
              div(style="font-weight: bold; font-size: 13px; color: #1e293b; margin-bottom: 8px;") Facturas Afectadas ({{ form.facturas.length }}):
              v-data-table(:headers="headersFacturas" :items="form.facturas" hide-actions class="elevation-1" style="border-radius: 8px; overflow: hidden;")
                template(v-slot:items="p")
                  td.text-xs-center(style="font-weight: bold; color: #0284c7;") {{ p.item.nro_factura }}
                  td.text-xs-center {{ p.item.nro_control || '-' }}
                  td.text-xs-center {{ p.item.fecha || '-' }}
                  td.text-xs-center(style="font-weight: 500;") Bs. {{ formatoMonto(p.item.base_imponible) }}
                  td.text-xs-center(style="font-weight: 500;") Bs. {{ formatoMonto(p.item.impuesto_iva) }}
                  td.text-xs-center(style="font-weight: bold; color: #10b981;") Bs. {{ formatoMonto(p.item.iva_retenido) }}

            //- Comprobante miniatura en el modal
            v-flex(xs12 v-if="form.comprobante" style="display: flex; justify-content: center; margin: 15px 0 10px 0;")
              div(style="text-align: center;")
                div(style="font-weight: 600; margin-bottom: 6px; font-size: 12px; color: #666;") COMPROBANTE ADJUNTO (Click para ampliar):
                div(v-if="form.comprobante.toLowerCase().endsWith('.pdf')" @click="verImagen(form)" style="display: inline-flex; align-items: center; gap: 8px; padding: 12px 20px; border-radius: 8px; background: #fff1f2; border: 1px solid #fecdd3; cursor: pointer;")
                  v-icon(color="red" size="32") picture_as_pdf
                  span(style="font-weight: bold; color: #9f1239;") Ver Documento PDF
                img(v-else :src="ruta + form.comprobante" @click="verImagen(form)" style="max-height: 220px; max-width: 100%; object-fit: contain; cursor: pointer; border-radius: 6px; border: 1px solid #ddd;")

        v-card-actions(style="padding: 16px; background: #f8f9fa;")
          v-spacer
          v-btn(v-if="form.estatus === 'Pendiente'" color="#0284c7" dark style="border-radius: 8px;" @click="cambiarEstatus(form, 'Pre Aprobada')")
            v-icon(left) fact_check
            | Pre Aprobar
          v-btn(v-if="form.estatus === 'Pre Aprobada' || form.estatus === 'Pre Aprobado'" color="success" style="border-radius: 8px;" @click="cambiarEstatus(form, 'Aprobado')")
            v-icon(left) check_circle
            | Aprobar
          v-btn(v-if="form.estatus === 'Pendiente' || form.estatus === 'Pre Aprobada' || form.estatus === 'Pre Aprobado'" color="error" style="border-radius: 8px;" @click="cambiarEstatus(form, 'Rechazado')")
            v-icon(left) cancel
            | Rechazar
          v-btn(style="background: black; color: white; border-radius: 8px;" @click="dialogDetalle = false")
            | Cerrar

    //- Filtros y Barra superior
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-layout(wrap style='justify-content: space-between; align-items: center; padding: 0 10px;')
          v-flex(xs12 sm3)
            v-text-field(v-model='search', label='Buscar cliente, vendedor o N° retención', prepend-inner-icon="search" clearable)
          v-flex(xs12 sm3 style='padding-left:15px;')
            v-select(:items='filtrosEstatus' v-model="filtroEstatus" label="Estatus" @change='cargarRetenciones()')
          v-flex(xs12 sm3 style='padding-left:15px;')
            v-menu(ref='menuFecha' v-model='menuFecha' :close-on-content-click='false' transition='scale-transition' offset-y max-width='320px' min-width='320px')
              template(v-slot:activator='{ on }')
                v-text-field(v-model='fechaRangoTexto' label='Rango de Fechas' prepend-inner-icon="date_range" readonly v-on='on' clearable @click:clear="limpiarFechas")
              v-date-picker(multiple v-model='fechas' no-title dark)
                v-btn(flat small color='primary' @click='seleccionarHoy') Hoy
                v-spacer
                v-btn(flat small color='grey' @click='limpiarFechas(); menuFecha = false') Limpiar
                v-btn(flat small color='primary' @click='menuFecha = false; cargarRetenciones()') OK
          v-flex(xs12 sm3 style='display: flex; justify-content: flex-end; align-items: center; gap: 12px;')
            v-btn(color="primary" dark style="border-radius: 8px;" @click="cargarRetenciones" :loading="loading")
              v-icon(left) refresh
              | Actualizar
            vue-excel-xlsx(
              v-if="dataExcel && dataExcel.length > 0"
              :data="dataExcel"
              :columns="columnsExcel"
              :filename="'Fercoven-Retenciones'"
              :sheetname="'Retenciones'"
              style="cursor: pointer;"
              title="Descargar Excel de Retenciones"
            )
              div(style="display: flex; flex-direction: column; font-size: 11px; font-weight: bold; text-align: center; align-items: center;")
                img(src="../assets/iconos/excel.png" style="height: 48px; width: auto;")
                span Retenciones

        //- Cabecera y Tabla
        v-card(style="border-radius: 0px 0px 20px 20px; background-color: black; margin-top: 10px;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Listado de Retenciones

        v-data-table.elevation-1(
          :headers='headers'
          :items='retenciones'
          :loading='loading'
          :search='search'
          :pagination.sync="pagination"
          style="margin-top: 5px;"
          no-data-text="No se encontraron retenciones"
        )
          template(slot='items', slot-scope='props')
            td.text-xs-center {{ props.item.nro }}
            td.text-xs-center {{ formatearFecha(props.item.fechaC) }}
            td
              div(style="font-weight: 600; color: #1e293b;") {{ props.item.cliente ? props.item.cliente.cli_des : 'N/A' }}
              div(style="font-size: 11px; color: #64748b;") {{ props.item.cliente ? props.item.cliente.rif : '' }} ({{ props.item.cliente ? props.item.cliente.co_cli : '' }})
            td.text-xs-center {{ props.item.ven_des || props.item.vendedor || 'N/A' }}
            td.text-xs-center
              span(style="font-weight: bold; color: #0284c7;") {{ props.item.nro_retencion }}
            td.text-xs-center
              span(style="font-weight: bold; color: #10b981;") ${{ formatoMonto(props.item.monto) }}
            td.text-xs-center
              v-tooltip(bottom v-if="props.item.observacion")
                template(v-slot:activator='{ on }')
                  v-chip(
                    small
                    :color="colorEstatus(props.item.estatus)"
                    text-color="white"
                    style="font-weight: 600; font-size: 11px; cursor: pointer;"
                    v-on="on"
                  ) {{ props.item.estatus }}
                span {{ props.item.estatus === 'Rechazado' ? 'Motivo: ' + props.item.observacion : props.item.observacion }}
              v-chip(
                v-else
                small
                :color="colorEstatus(props.item.estatus)"
                text-color="white"
                style="font-weight: 600; font-size: 11px;"
              ) {{ props.item.estatus }}
            td.text-xs-center
              div(v-if="props.item.comprobante")
                v-btn(icon small @click="verImagen(props.item)" title="Ver comprobante")
                  v-icon(color="red" v-if="props.item.comprobante.toLowerCase().endsWith('.pdf')") picture_as_pdf
                  v-icon(color="primary" v-else) image
              div(v-else style="color: #aaa; font-size: 11px;") Sin imagen
            td.text-xs-center
              v-layout(row justify-center)
                v-tooltip(bottom)
                  template(v-slot:activator='{ on }')
                    v-icon.mr-2(color='blue' @click='verDetalle(props.item)' v-on="on" style="cursor: pointer;") visibility
                  span Ver detalle
                v-tooltip(bottom v-if="props.item.estatus === 'Pendiente'")
                  template(v-slot:activator='{ on }')
                    v-icon.mr-2(color='#0284c7' @click='cambiarEstatus(props.item, "Pre Aprobada")' v-on="on" style="cursor: pointer;") fact_check
                  span Pre Aprobar
                v-tooltip(bottom v-if="props.item.estatus === 'Pre Aprobada' || props.item.estatus === 'Pre Aprobado'")
                  template(v-slot:activator='{ on }')
                    v-icon.mr-2(color='green' @click='cambiarEstatus(props.item, "Aprobado")' v-on="on" style="cursor: pointer;") check_circle
                  span Aprobar
                v-tooltip(bottom v-if="props.item.estatus === 'Pendiente' || props.item.estatus === 'Pre Aprobada' || props.item.estatus === 'Pre Aprobado'")
                  template(v-slot:activator='{ on }')
                    v-icon(color='red' @click='cambiarEstatus(props.item, "Rechazado")' v-on="on" style="cursor: pointer;") cancel
                  span Rechazar
</template>

<script>
import Api from "@/services/methods";
import { serverImg, server } from "@/services/environment";
import moment from "moment";

export default {
  name: "Retenciones",
  data: () => ({
    ruta: serverImg,
    serverUrl: server,
    visorPdfModo: "google",
    retenciones: [],
    loading: false,
    search: "",
    filtroEstatus: "Todos",
    fechas: [moment().format("YYYY-MM-DD")],
    menuFecha: false,
    dialogImg: false,
    dialogDetalle: false,
    itemSel: null,
    pagination: {
      rowsPerPage: 25,
      sortBy: "nro",
      descending: true
    },
    form: {
      nro: "",
      nro_retencion: "",
      montoDisplay: "",
      clienteNombre: "",
      clienteRif: "",
      vendedorNombre: "",
      fechaFormateada: "",
      estatus: "",
      observacion: "",
      comprobante: ""
    },
    filtrosEstatus: [
      { text: "Todos", value: "Todos" },
      { text: "Pendientes", value: "Pendiente" },
      { text: "Pre Aprobadas", value: "Pre Aprobada" },
      { text: "Aprobadas", value: "Aprobado" },
      { text: "Rechazadas", value: "Rechazado" }
    ],
    headers: [
      { text: "Nro", value: "nro", align: "center", sortable: true },
      { text: "Fecha", value: "fechaC", align: "center", sortable: true },
      { text: "Cliente", value: "cliente.cli_des", align: "left", sortable: true },
      { text: "Vendedor", value: "ven_des", align: "center", sortable: true },
      { text: "N° Retención", value: "nro_retencion", align: "center", sortable: true },
      { text: "Monto", value: "monto", align: "center", sortable: true },
      { text: "Estatus", value: "estatus", align: "center", sortable: true },
      { text: "Comprobante", value: "comprobante", align: "center", sortable: false },
      { text: "Acciones", value: "acciones", align: "center", sortable: false }
    ],
    headersFacturas: [
      { text: "Factura", value: "nro_factura", align: "center", sortable: false },
      { text: "Control", value: "nro_control", align: "center", sortable: false },
      { text: "Fecha", value: "fecha", align: "center", sortable: false },
      { text: "Base Imponible", value: "base_imponible", align: "center", sortable: false },
      { text: "Impuesto IVA", value: "impuesto_iva", align: "center", sortable: false },
      { text: "IVA Retenido", value: "iva_retenido", align: "center", sortable: false }
    ],
    columnsExcel: [
      { label: "Nro", field: "nro" },
      { label: "Fecha", field: "fecha" },
      { label: "Código Cliente", field: "co_cli" },
      { label: "Cliente", field: "cliente" },
      { label: "RIF", field: "rif" },
      { label: "Vendedor", field: "vendedor" },
      { label: "N° Retención", field: "nro_retencion" },
      { label: "Monto ($)", field: "monto" },
      { label: "Facturas", field: "facturas" },
      { label: "Estatus", field: "estatus" },
      { label: "Motivo de Rechazo / Observación", field: "motivo_rechazo" }
    ]
  }),
  computed: {
    retencionesFiltradasBusqueda() {
      if (!this.search || !this.search.trim()) return this.retenciones;
      const q = this.search.trim().toLowerCase();
      return this.retenciones.filter(el => {
        const nro = String(el.nro || "").toLowerCase();
        const nroRet = String(el.nro_retencion || "").toLowerCase();
        const cliDes = String(el.cliente && el.cliente.cli_des ? el.cliente.cli_des : "").toLowerCase();
        const cliCod = String(el.cliente && el.cliente.co_cli ? el.cliente.co_cli : "").toLowerCase();
        const cliRif = String(el.cliente && el.cliente.rif ? el.cliente.rif : "").toLowerCase();
        const ven = String(el.ven_des || el.vendedor || "").toLowerCase();
        const est = String(el.estatus || "").toLowerCase();
        const obs = String(el.observacion || "").toLowerCase();
        return (
          nro.includes(q) ||
          nroRet.includes(q) ||
          cliDes.includes(q) ||
          cliCod.includes(q) ||
          cliRif.includes(q) ||
          ven.includes(q) ||
          est.includes(q) ||
          obs.includes(q)
        );
      });
    },
    dataExcel() {
      return (this.retencionesFiltradasBusqueda || []).map(el => {
        const facturasList = Array.isArray(el.facturas)
          ? el.facturas.map(f => (typeof f === "object" ? f.nro_factura || f.nro_doc : f)).filter(Boolean).join(", ")
          : "";
        return {
          nro: el.nro || "N/A",
          fecha: this.formatearFecha(el.fechaC),
          co_cli: el.cliente && el.cliente.co_cli ? String(el.cliente.co_cli).trim() : "N/A",
          cliente: el.cliente && el.cliente.cli_des ? String(el.cliente.cli_des).trim() : "N/A",
          rif: el.cliente && el.cliente.rif ? String(el.cliente.rif).trim() : "N/A",
          vendedor: el.ven_des || el.vendedor || "N/A",
          nro_retencion: el.nro_retencion || "N/A",
          monto: el.monto != null && !isNaN(el.monto) ? parseFloat(el.monto) : 0,
          facturas: facturasList || "N/A",
          estatus: el.estatus || "N/A",
          motivo_rechazo: el.observacion && String(el.observacion).trim() !== "" ? String(el.observacion).trim() : "N/A"
        };
      });
    },
    fechaRangoTexto() {
      if (!this.fechas || !Array.isArray(this.fechas) || this.fechas.length === 0) return "";
      const ordenadas = [...this.fechas].sort();
      if (ordenadas.length === 1) return this.formatDate(ordenadas[0]);
      return `${this.formatDate(ordenadas[0])} ~ ${this.formatDate(ordenadas[1])}`;
    },
    urlPdfDirecta() {
      if (!this.itemSel || !this.itemSel.comprobante) return "";
      if (this.itemSel._id) {
        return `${this.serverUrl}/api/retenciones/pdf/${this.itemSel._id}`;
      }
      return this.ruta + this.itemSel.comprobante;
    },
    urlPdfActual() {
      if (!this.itemSel || !this.itemSel.comprobante) return "";
      const directUrl = this.ruta + this.itemSel.comprobante;
      if (this.visorPdfModo === "nativo") {
        if (this.itemSel._id) {
          return `${this.serverUrl}/api/retenciones/pdf/${this.itemSel._id}`;
        }
        return directUrl;
      }
      return `https://docs.google.com/viewer?url=${encodeURIComponent(directUrl)}&embedded=true`;
    }
  },
  watch: {
    fechas(val) {
      if (!Array.isArray(val)) {
        this.$nextTick(() => {
          this.fechas = val ? [val] : [];
        });
        return;
      }
      if (val.length > 2) {
        const nueva = val[val.length - 1];
        this.$nextTick(() => {
          this.fechas = [nueva];
        });
      } else if (val.length === 2 && val[0] > val[1]) {
        const ordenadas = [val[1], val[0]];
        this.$nextTick(() => {
          this.fechas = ordenadas;
        });
      }
    }
  },
  mounted() {
    this.cargarRetenciones();
  },
  methods: {
    cargarRetenciones() {
      this.loading = true;
      let url = "retenciones?limit=1000";
      if (this.filtroEstatus && this.filtroEstatus !== "Todos") {
        url += `&estatus=${encodeURIComponent(this.filtroEstatus)}`;
      }
      let desde = null;
      let hasta = null;
      if (this.fechas && Array.isArray(this.fechas) && this.fechas.length > 0) {
        const ordenadas = [...this.fechas].sort();
        desde = ordenadas[0];
        hasta = ordenadas.length > 1 ? ordenadas[1] : ordenadas[0];
        url += `&fechaDesde=${desde}&fechaHasta=${hasta.replace(/-/g, "/")}`;
      }

      Api.get(url)
        .then(res => {
          this.loading = false;
          let lista = [];
          if (res && res.data) {
            lista = res.data.data || res.data;
          } else if (Array.isArray(res)) {
            lista = res;
          }
          if (!Array.isArray(lista)) lista = [];

          if (desde && hasta) {
            lista = lista.filter(item => {
              if (!item.fechaC) return false;
              const fechaDia = moment.utc(item.fechaC).format("YYYY-MM-DD");
              return fechaDia >= desde && fechaDia <= hasta;
            });
          }

          this.retenciones = lista;
        })
        .catch(err => {
          this.loading = false;
          console.error("Error al cargar retenciones:", err);
          this.$swal({
            type: "error",
            title: "Error",
            text: "No se pudieron obtener las retenciones."
          });
        });
    },

    formatDate(date) {
      if (!date) return "";
      const parts = String(date).split("-");
      if (parts.length !== 3) return date;
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    },

    seleccionarHoy() {
      this.fechas = [moment().format("YYYY-MM-DD")];
      this.menuFecha = false;
      this.cargarRetenciones();
    },

    limpiarFechas() {
      this.fechas = [];
      this.cargarRetenciones();
    },

    formatearFecha(f) {
      if (!f) return "N/A";
      return moment.utc(f).format("DD/MM/YYYY hh:mm A");
    },

    formatoMonto(m) {
      if (m == null || isNaN(m)) return "0.00";
      return parseFloat(m).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    colorEstatus(estatus) {
      if (estatus === "Aprobado" || estatus === "Aprobada") return "green";
      if (estatus === "Pre Aprobada" || estatus === "Pre Aprobado") return "#0284c7";
      if (estatus === "Rechazado" || estatus === "Rechazada") return "red";
      return "orange";
    },

    verImagen(item) {
      this.itemSel = item;
      this.dialogImg = true;
    },

    verDetalle(item) {
      this.form = {
        ...item,
        montoDisplay: `$${this.formatoMonto(item.monto)}`,
        clienteNombre: item.cliente ? item.cliente.cli_des : "N/A",
        clienteRif: item.cliente ? item.cliente.rif : "N/A",
        vendedorNombre: item.ven_des || item.vendedor || "N/A",
        fechaFormateada: this.formatearFecha(item.fechaC)
      };
      this.dialogDetalle = true;
    },

    cambiarEstatus(item, nuevoEstatus) {
      if (nuevoEstatus === "Rechazado") {
        this.$swal.fire({
          title: "Motivo del rechazo",
          text: `Retención N°: ${item.nro_retencion || item.nro} - Monto: $${this.formatoMonto(item.monto)}`,
          input: "text",
          inputPlaceholder: "Ingrese el motivo del rechazo...",
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonColor: "#F44336",
          confirmButtonText: "Rechazar",
          cancelButtonText: "Cancelar",
          reverseButtons: true
        }).then(result => {
          if (result.dismiss) {
            // Cancelado por el usuario
          } else if (result.value && result.value.trim().length > 0) {
            const observacion = result.value.trim();
            this.loading = true;
            const payload = {
              estatus: "Rechazado",
              observacion: observacion,
              usuario: this.$store.state.adminfercoven ? this.$store.state.adminfercoven._id : null,
              accion: `Modificación de estatus (Rechazado), Retención N°: ${item.nro_retencion || item.nro}`
            };

            Api.put(`retenciones/${item._id}`, payload)
              .then(() => {
                this.loading = false;
                this.dialogDetalle = false;
                this.$swal.fire(
                  "¡Retención Rechazada!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.cargarRetenciones();
              })
              .catch(err => {
                this.loading = false;
                console.error("Error al rechazar retención:", err);
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
              });
          } else {
            this.$swal.fire(
              "¡Atención!",
              "Debe ingresar el motivo del rechazo.",
              "error"
            );
          }
        });
      } else if (nuevoEstatus === "Pre Aprobada") {
        this.$swal.fire({
          title: "¿Desea pre-aprobar la retención?",
          text: `N° Retención: ${item.nro_retencion || item.nro} - Monto: $${this.formatoMonto(item.monto)}`,
          type: "question",
          showCancelButton: true,
          confirmButtonColor: "#0284c7",
          cancelButtonColor: "#333",
          confirmButtonText: "Sí, pre-aprobar",
          cancelButtonText: "Cancelar",
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            this.loading = true;
            const payload = {
              estatus: "Pre Aprobada",
              usuario: this.$store.state.adminfercoven ? this.$store.state.adminfercoven._id : null,
              accion: `Modificación de estatus (Pre Aprobada), Retención N°: ${item.nro_retencion || item.nro}`
            };

            Api.put(`retenciones/${item._id}`, payload)
              .then(() => {
                this.loading = false;
                this.dialogDetalle = false;
                this.$swal.fire(
                  "¡Retención Pre Aprobada!",
                  "La retención pasó a estatus Pre Aprobada exitosamente.",
                  "success"
                );
                this.cargarRetenciones();
              })
              .catch(err => {
                this.loading = false;
                console.error("Error al pre-aprobar retención:", err);
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
              });
          }
        });
      } else {
        this.$swal.fire({
          title: "¿Desea aprobar definitivamente la retención?",
          text: `N° Retención: ${item.nro_retencion || item.nro} - Monto: $${this.formatoMonto(item.monto)}`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4CAF50",
          cancelButtonColor: "#333",
          confirmButtonText: "Sí, aprobar",
          cancelButtonText: "Cancelar",
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            this.loading = true;
            const payload = {
              estatus: "Aprobado",
              usuario: this.$store.state.adminfercoven ? this.$store.state.adminfercoven._id : null,
              accion: `Modificación de estatus (Aprobado), Retención N°: ${item.nro_retencion || item.nro}`
            };

            Api.put(`retenciones/${item._id}`, payload)
              .then(() => {
                this.loading = false;
                this.dialogDetalle = false;
                this.$swal.fire(
                  "¡Retención Aprobada!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.cargarRetenciones();
              })
              .catch(err => {
                this.loading = false;
                console.error("Error al aprobar retención:", err);
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
              });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.withTd2 {
  padding: 8px !important;
  border: 1px solid #e2e8f0;
}
</style>
